import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';
import { genderLabel } from '../utils/format';
import { jobTypeShort } from '../constants/jobTypes';

function CandidateDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState('');

  useEffect(() => {
    api.get(`/candidates/${id}`)
      .then(res => setCandidate(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  const handleShare = (type) => {
    const url = window.location.href;
    const text = `${candidate.name} - ${candidate.title} | RollSleeves 涉外人才`;

    if (type === 'copy') {
      navigator.clipboard.writeText(url);
      setToast('链接已复制');
    } else if (type === 'wechat') {
      navigator.clipboard.writeText(`${text}\n${url}`);
      setToast('内容已复制，请粘贴到微信分享');
    } else if (type === 'email') {
      window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
    }

    if (toast) setTimeout(() => setToast(''), 2000);
  };

  if (loading) return <div className="loading">加载中...</div>;
  if (!candidate) return <div className="empty-state"><p>候选人资料不存在或未公开</p></div>;

  return (
    <div className="profile-page">
      <Link to="/candidates" style={{ color: 'var(--text-light)', textDecoration: 'none', fontSize: '0.9rem' }}>
        ← 返回人才广场
      </Link>

      <div className="card" style={{ marginTop: 20, padding: 32 }}>
        <div className="candidate-card-header" style={{ marginBottom: 24 }}>
          <div className="candidate-avatar" style={{ width: 72, height: 72, fontSize: '1.6rem' }}>
            {(candidate.name || '?')[0]}
          </div>
          <div>
            <div className="candidate-name" style={{ fontSize: '1.4rem' }}>{candidate.name}</div>
            <div className="candidate-title-text" style={{ fontSize: '1rem' }}>{candidate.title || '涉外专业人才'}</div>
            {candidate.location && <div style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginTop: 4 }}>{candidate.location}</div>}
            {genderLabel(candidate.userGender) && (
              <div style={{ color: 'var(--text-light)', fontSize: '0.9rem', marginTop: 2 }}>
                性别：{genderLabel(candidate.userGender)}
              </div>
            )}
          </div>
        </div>

        <div className="job-card-meta" style={{ marginBottom: 20 }}>
          {candidate.experience && <span className="tag tag-green">{candidate.experience}</span>}
          {candidate.jobTypes && <span className="tag">{
            '期望：' + (jobTypeShort(candidate.jobTypes) || candidate.jobTypes)
          }</span>}
          {candidate.expectedSalary && <span className="tag tag-amber">期望薪资: {candidate.expectedSalary}</span>}
        </div>

        {candidate.summary && (
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: '1rem', marginBottom: 8 }}>个人简介</h3>
            <p style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>{candidate.summary}</p>
          </div>
        )}

        {candidate.education && (
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: '1rem', marginBottom: 8 }}>教育背景</h3>
            <p style={{ lineHeight: 1.8, color: 'var(--text-secondary)', whiteSpace: 'pre-wrap' }}>{candidate.education}</p>
          </div>
        )}

        {candidate.skills && (
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: '1rem', marginBottom: 8 }}>专业技能</h3>
            <div className="candidate-skills">
              {candidate.skills.split(',').map((skill, i) => (
                <span key={i} className="tag tag-purple">{skill.trim()}</span>
              ))}
            </div>
          </div>
        )}

        {candidate.languages && (
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: '1rem', marginBottom: 8 }}>语言能力</h3>
            <p style={{ color: 'var(--text-secondary)' }}>{candidate.languages}</p>
          </div>
        )}

        {(candidate.contactEmail || candidate.contactPhone || candidate.linkedIn) && (
          <div className="job-detail-sidebar">
            <h3 style={{ fontSize: '1rem', marginBottom: 12 }}>联系方式</h3>
            {candidate.contactEmail && <p><strong>邮箱：</strong>{candidate.contactEmail}</p>}
            {candidate.contactPhone && <p><strong>电话/微信：</strong>{candidate.contactPhone}</p>}
            {candidate.linkedIn && <p><strong>LinkedIn：</strong>{candidate.linkedIn}</p>}
          </div>
        )}

        {/* 联系候选人 */}
        {user && candidate.userId !== user.id && (
          <div style={{ marginTop: 20 }}>
            <button
              className="btn btn-primary btn-lg"
              style={{ width: '100%' }}
              onClick={() => navigate(`/messages?to=${candidate.userId}&name=${encodeURIComponent(candidate.name)}&candidateId=${candidate.id}&subject=${encodeURIComponent(candidate.name + ' - ' + (candidate.title || '候选人'))}`)}
            >
              私信联系 {candidate.name}
            </button>
          </div>
        )}
        {!user && (
          <div style={{ marginTop: 16, textAlign: 'center', fontSize: '0.9rem', color: 'var(--text-light)' }}>
            <Link to="/login" style={{ color: 'var(--primary)' }}>登录</Link> 后可以私信联系候选人
          </div>
        )}

        <div className="share-bar">
          <span>分享此资料：</span>
          <button className="share-btn" onClick={() => handleShare('copy')}>复制链接</button>
          <button className="share-btn" onClick={() => handleShare('wechat')}>微信分享</button>
          <button className="share-btn" onClick={() => handleShare('email')}>邮件分享</button>
        </div>
      </div>

      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

export default CandidateDetail;
